import React from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";

const SEGMENTS = [
  { key: "medical_specialty", label: "Medical", color: "#0B7E8C", max: 30 },
  { key: "sub_specialty", label: "Sub-spec.", color: "#14B8A6", max: 20 },
  { key: "specialty_level", label: "Level", color: "#64748B", max: 15 },
  { key: "distance", label: "Distance", color: "#3B82F6", max: 20 },
  { key: "workload", label: "Workload", color: "#F59E0B", max: 10 },
  { key: "readiness", label: "Readiness", color: "#10B981", max: 5 },
];

const round1 = (n) => Math.round((n || 0) * 10) / 10;

// Segmented score breakdown bar for a recommendation (max 100 pts total).
export function BreakdownBar({ breakdown }) {
  if (!breakdown) return null;
  return (
    <div className="mb-2" data-testid="fleet-rec-breakdown">
      <div className="flex h-1.5 rounded-full overflow-hidden bg-[#F1F5F9]">
        {SEGMENTS.map((s) => {
          const pts = round1(breakdown[s.key]);
          if (pts <= 0) return null;
          return <div key={s.key} title={`${s.label}: ${pts}/${s.max}`} style={{ width: `${pts}%`, background: s.color }} />;
        })}
      </div>
      <div className="flex flex-wrap gap-x-2 gap-y-0.5 mt-1">
        {SEGMENTS.filter((s) => (breakdown[s.key] || 0) > 0).map((s) => (
          <span key={s.key} className="text-[9px] text-[#94A3B8] inline-flex items-center gap-0.5">
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.color }} />
            {s.label} {round1(breakdown[s.key])}
          </span>
        ))}
      </div>
    </div>
  );
}

// Specialty match chip: green when matched, amber when not, grey when neutral.
export function SpecChip({ ok, label }) {
  const cls = ok === false
    ? "bg-[#FEF3C7] text-[#92400E]"
    : ok === true
      ? "bg-[#D1FAE5] text-[#065F46]"
      : "bg-[#F1F5F9] text-[#475569]";
  return (
    <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium inline-flex items-center gap-0.5 ${cls}`}>
      {ok === true && <CheckCircle2 className="w-2.5 h-2.5" />}
      {ok === false && <AlertTriangle className="w-2.5 h-2.5" />}
      {label}
    </span>
  );
}
